/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    FetchCFVideoResponse,
    UploadCFImageResponse,
    UploadCFVideoResponse,
} from '../models';

export interface CloudflareApiControllerCloudflareVideoRequest {
    videoId: string;
}

export interface CloudflareApiControllerUploadCloudflareImageRequest {
    file?: Blob;
}

export interface CloudflareApiControllerUploadCloudflareVideoRequest {
    file?: Blob;
}

/**
 * 
 */
export class CloudflareApi extends runtime.BaseAPI {

    /**
     */
    async cloudflareApiControllerCloudflareVideoRaw(requestParameters: CloudflareApiControllerCloudflareVideoRequest): Promise<runtime.ApiResponse<FetchCFVideoResponse>> {
        if (requestParameters.videoId === null || requestParameters.videoId === undefined) {
            throw new runtime.RequiredError('videoId','Required parameter requestParameters.videoId was null or undefined when calling cloudflareApiControllerCloudflareVideo.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/cloudflare/video/{videoId}`.replace(`{${"videoId"}}`, encodeURIComponent(String(requestParameters.videoId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async cloudflareApiControllerCloudflareVideo(requestParameters: CloudflareApiControllerCloudflareVideoRequest): Promise<FetchCFVideoResponse> {
        const response = await this.cloudflareApiControllerCloudflareVideoRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async cloudflareApiControllerUploadCloudflareImageRaw(requestParameters: CloudflareApiControllerUploadCloudflareImageRequest): Promise<runtime.ApiResponse<UploadCFImageResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        const response = await this.request({
            path: `/v1/cloudflare/image:upload`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async cloudflareApiControllerUploadCloudflareImage(requestParameters: CloudflareApiControllerUploadCloudflareImageRequest): Promise<UploadCFImageResponse> {
        const response = await this.cloudflareApiControllerUploadCloudflareImageRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async cloudflareApiControllerUploadCloudflareVideoRaw(requestParameters: CloudflareApiControllerUploadCloudflareVideoRequest): Promise<runtime.ApiResponse<UploadCFVideoResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        const response = await this.request({
            path: `/v1/cloudflare/video:upload`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async cloudflareApiControllerUploadCloudflareVideo(requestParameters: CloudflareApiControllerUploadCloudflareVideoRequest): Promise<UploadCFVideoResponse> {
        const response = await this.cloudflareApiControllerUploadCloudflareVideoRaw(requestParameters);
        return await response.value();
    }

}
